<template>
  <v-row>
    <v-col>
      <Table
        :items="items"
        :headers="allHeaders"
        :openDialog="openDialog"
        @headersUpdated="updateHeaders"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
      />
      <v-dialog
        v-model="open"
        max-width="500px"
        persistent
        @keydown.esc="reset(false)"
      >
        <Form
          :itemsSelect="dataSelects"
          :items="dataInputs"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import Form from "@/components/Complement/Form";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import modelsLiquidation from "@/store/modelosDeLiquidacion/modelsLiquidation";
import firm from "@/models/modelosDeLiquidacion/Relations/firm";
import date from "@/store/common/date";
import operators from "@/store/workflow/operators";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("modelsLiquidations.firms"),
      titleTable: "ModelosDeLiquidacion_Firmas",
      titleDelete: this.$tc("modelsLiquidations.toFirmLiquidation"),
      isLoading: true,
      nameOper: "",
      maxWidth: ["500px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      headers: [
        {
          text: "Nombre operador",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Orden",
          value: "order",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      dataInputs: [
        {
          name: "order",
          label: "Orden",
          data: "",
          type: "Number",
          rules: [
            (v) => !!v || this.$tc("validation.required"),
            (v) => v >= 1 || this.$tc("validation.greaterThanZero"),
            (v) =>
              v < 10000000 || `${this.$t("validation.maxDigits", { max: 7 })}`,
          ],
        },
      ],
    };
  },
  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    items() {
      if (
        !modelsLiquidation.state.edit.firmas ||
        modelsLiquidation.state.edit.firmas.length === 0
      ) {
        return [];
      }

      return modelsLiquidation.state.edit.firmas.map((item) => {
        return firm.fromJson(item);
      });
    },
    operators() {
      return operators.state.operators;
    },

    operatorsSelected() {
      const editOperators = this.editOperators;

      if (!editOperators || editOperators.length === 0) {
        return operators.state.operators;
      }

      return operators.state.operators.filter(
        (operator) =>
          !editOperators.some((selected) => selected.operId === operator.operId)
      );
    },

    editOperators() {
      return modelsLiquidation.state.edit.firmas;
    },

    dataSelects() {
      return [
        {
          name: "operId",
          label: "Operadores",
          data: "",
          items: [],
          itemsValue: "operId",
          itemsText: "nombre",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
          readonly: false,
        },
      ];
    },

    mode: {
      get() {
        return modelsLiquidation.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return modelsLiquidation.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return modelsLiquidation.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    await operators.dispatch("getOperators");
    this.isLoading = false;
  },
  methods: {
    async refreshItems() {
      if (modelsLiquidation.state.edit.id) {
        await modelsLiquidation.dispatch(
          "getLiquidationModelId",
          modelsLiquidation.state.edit.id
        );
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    addFirm(form) {
      let payload = form;
      payload.liqModeloId = modelsLiquidation.state.edit.id;
      modelsLiquidation.commit("setNew", payload);
      modelsLiquidation
        .dispatch("addFirm")
        .then(() => {
          this.showAlert(
            this.$tc("modelsLiquidations.addFirmToLiquidationSuccess"),
            "#82A1D0"
          );
        })
        .catch((error) => {
          if (error.response && error.response.status === 406) {
            this.showAlert(
              this.$tc("modelsLiquidations.errorFirm406"),
              "#ff8d58"
            );
          } else {
            this.showAlert(this.$tc("modelsLiquidations.errorFirm"), "#ff8d58");
          }
          reject(error);
        });
      this.reset(false);
    },

    editFirm(form) {
      let payload = this.detectChanges(form);
      if (Object.keys(payload).length > 0) {
        payload.liqModeloId = modelsLiquidation.state.edit.id;
        payload.orderOld = this.oldItems.order;
        payload.operId = Number(form.operId);
        payload.name = this.nameOper;
        modelsLiquidation.commit("setEditRelation", payload);
        modelsLiquidation
          .dispatch("editFirm")
          .then(() => {
            this.showAlert(
              this.$tc("modelsLiquidations.editFirmToLiquidationSuccess"),
              "#82A1D0"
            );
          })
          .catch((error) => {
            if (error.response && error.response.status === 406) {
              this.showAlert(
                this.$tc("modelsLiquidations.errorFirm406"),
                "#ff8d58"
              );
            } else {
              this.showAlert(
                this.$tc("modelsLiquidations.errorFirm"),
                "#ff8d58"
              );
            }
            reject(error);
          });
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }

      this.reset(false);
    },
    detectChanges(newItems) {
      const changes = {};
      const oldItem = this.oldItems;

      if (oldItem) {
        if (oldItem.order !== Number(newItems.order)) {
          changes.order = newItems.order;
        }

        if (oldItem.id !== Number(newItems.operId)) {
          changes.operId = newItems.name;
        }
      }

      return changes;
    },

    async openDialog(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          this.dataSelects[0].items = this.operatorsSelected;
          this.dataSelects[0].readonly = false;
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.addFirmToLiquidation")
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "edit":
          this.dataSelects[0].items = this.operators;
          this.dataSelects[0].readonly = true;
          this.oldItems = item;
          this.itemId = item.id;
          await this.setEdit(item);
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.editFirmToLiquidation")
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "delete":
          modelsLiquidation.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            liqModeloId: modelsLiquidation.state.edit.id,
          };
          break;

        default:
          break;
      }
    },

    setEdit(item) {
      this.nameOper = item.name;
      this.dataSelects[0].data = item.id;
      this.dataInputs[0].data = item.order;
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset(value) {
      this.resetDate();
      modelsLiquidation.commit("setOpenFormRelation", value);
      this.dataInputs.forEach((item) => {
        item.data = "";
      });
      this.dataSelects.forEach((item) => {
        item.data = "";
      });
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addFirm(items);
          break;
        case "edit":
          this.editFirm(items);
          break;
        default:
          break;
      }
    },

    deleteItem() {
      modelsLiquidation.commit("setItemDelete", this.itemToDelete);
      modelsLiquidation
        .dispatch("deleteFirm")
        .then(() => {
          this.openDelete = false;
          modelsLiquidation.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("modelsLiquidations.deleteFirmToLiquidationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(this.$tc("modelsLiquidations.errorFirm"), "#ff8d58");
        });
    },

    cancelDelete() {
      this.openDelete = false;
      modelsLiquidation.commit("setOpenDelete", false);
    },
  },
};
</script>
